import { ActionWorkflowNode } from 'app/core/enums';
import { InProgressTreatment } from 'app/core/models/treatment/in-progress-treatment.model';
import { isNeerVeneerLike } from './is-neer-veneer-like';

export type ApproveFilesPaymentOrder = Pick<
  InProgressTreatment,
  'extraMetadata' | 'isPaid' | 'treatmentTypeId' | 'upgradeFromTreatment'
>;

export function shouldShowApproveFilesAndPay(order?: ApproveFilesPaymentOrder | null): boolean {
  if (order == null) {
    return false;
  }

  const isUpgradeOrRedesign =
    order.upgradeFromTreatment != null ||
    order.extraMetadata?.currentAction === ActionWorkflowNode.UpgradeToVeneers ||
    order.extraMetadata?.currentAction === ActionWorkflowNode.Redesign;

  return isNeerVeneerLike(order.treatmentTypeId) && order.isPaid === false && !isUpgradeOrRedesign;
}
